
import Vue from 'vue';

export default Vue.extend({
	name: 'BaseButton',
	props: {
		loading: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
		elevation: { type: Number, default: 0 },
		secondary: { type: Boolean, default: false },
		secondaryPrimary: { type: Boolean, default: false },
		superPrimary: { type: Boolean, default: false },
		tertiary: { type: Boolean, default: false },
		warning: { type: Boolean, default: false },
		warningConfirm: { type: Boolean, default: false },
		text: { type: Boolean, default: false },
		link: { type: Boolean, default: false },
		rounded: { type: Boolean, default: true },
		color: { type: String, default: null },
		callToAction: { type: Boolean, default: false },
		cssClass: { type: [String, Object], default: 'px-4 font-weight-bold' },
		white: { type: Boolean, default: false },
		admin: { type: Boolean, default: false },
	},
	computed: {
		isPrimary () {
			return (
				!this.disabled &&
				!this.superPrimary &&
				!this.secondary &&
				!this.secondaryPrimary &&
				!this.callToAction &&
				!this.text &&
				!this.warning &&
				!this.warningConfirm &&
				!this.tertiary &&
				!this.link &&
				!this.white &&
				!this.admin
			);
		},
		isSuperPrimary () {
			return (
				this.superPrimary &&
				!this.disabled &&
				!this.secondary &&
				!this.secondaryPrimary &&
				!this.primary &&
				!this.callToAction &&
				!this.text &&
				!this.warning &&
				!this.warningConfirm &&
				!this.link &&
				!this.white &&
				!this.admin
			);
		},
		isSecondary () {
			return (
				this.secondary &&
				!this.callToAction &&
				!this.secondaryPrimary &&
				!this.text &&
				!this.link &&
				!this.white &&
				!this.admin
			);
		},
		isSecondaryPrimary () {
			return (
				this.secondaryPrimary &&
				!this.primary &&
				!this.superPrimary &&
				!this.secondary &&
				!this.callToAction &&
				!this.text &&
				!this.link &&
				!this.disabled &&
				!this.white &&
				!this.admin
			);
		},
		isTertiary () {
			return (
				this.tertiary &&
				!this.secondary &&
				!this.secondaryPrimary &&
				!this.callToAction &&
				!this.text &&
				!this.white &&
				!this.admin
			);
		},
		isLink () {
			return (
				this.link &&
				!this.callToAction
			);
		},
		isWhite () {
			return (
				this.white &&
				!this.disabled &&
				!this.superPrimary &&
				!this.secondary &&
				!this.secondaryPrimary &&
				!this.callToAction &&
				!this.text &&
				!this.warning &&
				!this.warningConfirm &&
				!this.tertiary &&
				!this.link &&
				!this.admin
			);
		},
		isAdmin () {
			return (
				this.admin &&
				!this.disabled &&
				!this.superPrimary &&
				!this.secondary &&
				!this.secondaryPrimary &&
				!this.callToAction &&
				!this.text &&
				!this.warning &&
				!this.warningConfirm &&
				!this.tertiary &&
				!this.link &&
				!this.white
			);
		},
		btnColor () {
			let color = '';

			if (this.secondary) {
				color = '#b0bec5';
			} else if (this.callToAction) {
				color = 'rgba(160, 170, 236, 1)';
			} else if (this.warning || this.warningConfirm) {
				color = '#dc2626';
			} else if (this.isTertiary) {
				color = '#424242FF';
			} else if (this.isAdmin) {
				color = 'deep-orange';
			}

			// Override if given color prop
			if (this.color) {
				color = this.color;
			}

			return color;
		},
	},
});
